export default __webpack_public_path__ + "static/media/unverifiedinfo.82add774.svg";